import React from 'react';
import { connect } from 'react-redux';
import { authHeader, config, redirectToPdfV2 } from '_helpers';
import {
  applicantsActions,
  permissionActions,
  createProfileActions,
  resourceActions,
} from '_actions';
import 'assets/styles/applicants.css';
import moment from 'moment';
import ReactModal from 'react-modal';
import { AlertPopup } from '../_components/AlertPopup';
import { toast } from 'react-toastify';
import NoInterviewFormAlert from '_components/NoInterviewFormAlert/NoInterviewFormAlert';
import Modal from '_components/utils/Modal/Modal';
import AsyncSelect from 'react-select/async';
import Select from 'react-select';
import DateAndTimePicker from '_components/utils/DateAndTimePicker/DateAndTimePicker';
import { handleErrorResponse } from '_helpers/helpers';
import { formatDate } from '_helpers/helpers';
import { contactEmailConstants, profileType } from '_constants';
import SmsNotification from 'SmsNotification/SmsNotification';
import PropTypes from 'prop-types';
import ApplicantDetailsSection from './Partials/ApplicantDetailsSection';

ReactModal.setAppElement('#app');

function formatPhoneNumber(s) {
  const s2 = ('' + s).replace(/\D/g, '');
  const m = s2.match(/^(\d{3})(\d{3})(\d{4})$/);
  return !m ? null : m[1] + '-' + m[2] + '-' + m[3];
}

const APPLICATIONSTATUSES = {
  received: 1,
  inReview: 3,
  offeredPosition: 4,
  wasHired: 2,
  notSelected: 0,
  doNotHire: 10,
};

const statusApplication = {
  NOT_SELECTED_ARCHIVE: 0,
  RECIEVED: 1,
  WAS_HIRED: 2,
  IN_REVIEW: 3,
  OFFERED_POSITION: 4,
  DO_NOT_HIRE_ARCHIVE: 10,
};

class ViewApplicant extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      statusUpdating: false,
      flag: true,
      applicationItem: [],
      // TODO: remove notes if not used
      notes: '',
      statusOpen: false,
      onboardingEmailStatusOpen: false,
      sendOnboardingEmail: false,
      removeStatusOpen: false,
      hash: this.props.hash,
      email: this.props.email ?? '',
      // selected: '',
      applicant_list: [],
      hideSearch: 'hide',
      user_list: [],
      application_history: [],
      to: '',
      forwardingNote: '',
      crews: [],
      applicant_details: null,
      applicantStatusList: [],
      applicantStatus: 0,
      crew: '',
      whoSelected: '',
      whoRejected: '',
      rejectionReason: '',
      date: moment(),
      time: moment(),
      isConfirmUpdateModalOpen: false,
      isNotesOpen: false,
      selectedApplicantNote: '',
      editableNote: { note: '', id: '' },
      noteEditMode: false,
      reasonEditMode: false,
      onOutsideClick: false,
      FULL_DATE_FORMAT: 'MM/DD/YYYY',
      applicationStatus: null,
      interviewFormSubmissionDate: moment(),
      formerEmpModal: false,
      formerEmpApproval: null,
      admin_reason_for_leaving: '',
    };
    this.prevNext = this.prevNext.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.headerSearch = this.headerSearch.bind(this);
    this.statusOpenModal = this.statusOpenModal.bind(this);
    this.onboardingEmailStatusOpenModal =
      this.onboardingEmailStatusOpenModal.bind(this);
    this.statusCloseModal = this.statusCloseModal.bind(this);
    this.onboardingEmailStatusCloseModal =
      this.onboardingEmailStatusCloseModal.bind(this);
    this.removeStatusOpenModal = this.removeStatusOpenModal.bind(this);
    this.removeStatusCloseModal = this.removeStatusCloseModal.bind(this);
    this.updateApplicantStatus = this.updateApplicantStatus.bind(this);
    this.sendMail = this.sendMail.bind(this);
    this.forwardApplicant = this.forwardApplicant.bind(this);
    this.keyUpFn = this.keyUpFn.bind(this);
    this.goBack = this.goBack.bind(this);
    this.userClick = this.userClick.bind(this);
    this.onImageError = this.onImageError.bind(this);
    this.closeAlert = this.closeAlert.bind(this);
    this.checkNull = this.checkNull.bind(this);
    this.onForwardingNote = this.onForwardingNote.bind(this);
    this.onChangeUpdateApplicantStatus =
      this.onChangeUpdateApplicantStatus.bind(this);
    this.onChangeUpdateApplicantDate =
      this.onChangeUpdateApplicantDate.bind(this);
    this.onChangeUpdateApplicantTime =
      this.onChangeUpdateApplicantTime.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.onChangeSelect = this.onChangeSelect.bind(this);
    this.findCurrentCrew = this.findCurrentCrew.bind(this);
    this.findWhoSelected = this.findWhoSelected.bind(this);
  }

  onChangeUpdateApplicantStatus(e) {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  }

  handleSelect(e) {
    const { value } = e.target;
    this.setState({ formerEmpApproval: value });
  }

  formerEmpOpenModal() {
    this.setState({ formerEmpModal: true });
  }

  formerEmpCloseModal() {
    this.setState({ formerEmpModal: false });
  }

  changeFormerEmpApprovalStatus() {
    this.setState({ statusUpdating: true });

    let data = new FormData();
    data.append('hash', this.state.hash);
    data.append('approval_status', this.state.formerEmpApproval);

    this.props
      .dispatch(applicantsActions.changeFormerEmployeeApprovalStatus(data))
      ?.then((res) => {
        if (res?.success) {
          window.location.href = '/former-employed-applicants';
          this.formerEmpCloseModal();
          this.setState({
            statusUpdating: false,
          });
        } else {
          handleErrorResponse(res);
          this.setState({ statusUpdating: false });
        }
      })
      ?.catch((err) => {
        this.setState({ statusUpdating: false });
        throw err;
      });
  }

  statusOpenModal(hash, status, selectedApplicantNoInterviewForms) {
    this.setState({
      statusOpen: true,
      removeApplicant: hash,
      currentStatusUpdate: status > -1 ? status : '',
      selectedApplicantNoInterviewForms,
    });
  }

  onboardingEmailStatusOpenModal() {
    this.setState({
      onboardingEmailStatusOpen: true,
    });
  }

  onboardingEmailStatusCloseModal() {
    this.setState({
      onboardingEmailStatusOpen: false,
    });
  }

  sendOnboardingEmail() {
    this.setState({
      sendingOnboardingEmail: true,
    });

    fetch(
      `${config.apiUrl}/api/applicant/${this.props.applicants?.list?.data?.id}/send-onboarding-email`,
      {
        headers: authHeader(),
        method: 'POST',
      },
    )
      .then((res) => res.json()) // <-- arrow function
      .then((data) => {
        this.setState({ sendingOnboardingEmail: false });
        this.onboardingEmailStatusCloseModal();

        if (data.success) {
          toast.success('Sent Onboarding Email successfully.');
        } else {
          toast.error('Failed to send email. ' + JSON.stringify(data.message));
        }
      })
      .catch((err) => {
        this.setState({ sendingOnboardingEmail: false });
        this.onboardingEmailStatusCloseModal();
        toast.error('Something went wrong.');
      });
  }

  onChangeUpdateApplicantDate(date) {
    this.setState({ date });
  }

  onChangeUpdateApplicantTime(time) {
    this.setState({ time });
  }

  onChangeSelect(selected, type) {
    this.setState({ [type]: selected.value });
    if (type === 'whoSelected') {
      this.setState({ whoRejected: '', rejectionReason: '' });
    } else if (type === 'whoRejected') {
      this.setState({ whoSelected: '', crew: '' });
    } else if (
      (type === 'applicantStatus' &&
        selected.value === statusApplication.RECIEVED) ||
      selected.value === statusApplication.IN_REVIEW ||
      selected.value === statusApplication.OFFERED_POSITION
    ) {
      this.setState({
        whoRejected: '',
        rejectionReason: '',
        whoSelected: '',
        crew: '',
      });
    }
  }

  async handleSearch(value, type) {
    let data = new FormData();
    data.append('keyword', value);
    let response = [];
    switch (type) {
      case 'crew':
        const crews = await this.props.dispatch(
          resourceActions.searchResource(data),
        );
        response = crews;
        break;
      case 'who selected':
      case 'who rejected':
        const employees = await this.props.dispatch(
          resourceActions.employeeList(data),
        );
        response = employees?.data;
        break;
      default:
        break;
    }

    const items = response?.data;
    let res = [];
    let options = [];

    if (type === 'who selected' || type === 'who rejected') {
      options = items.map((emp) => ({
        ...emp,
        value: emp.userid,
        label: `${emp.last_name} ${emp.first_name}`,
      }));
      return options;
    }

    for (let key in items) {
      let arr = items[key];
      if (arr.length) {
        res = res.concat(arr);
      }
    }

    options = res.map((item) => ({
      label: item?.resource_name,
      value: item?.id,
    }));

    return options;
  }

  loadOptions = (value, callback, type) => {
    setTimeout(async () => {
      const res = await this.handleSearch(value, type);
      callback(res);
    }, 500);
  };

  componentDidMount() {
    this.props.dispatch(createProfileActions.getAll());
    this.props.dispatch(applicantsActions.viewDetails(this.state.hash));
    this.props.dispatch(permissionActions.getPermission());
  }

  findLabelsForCrewAndWhoSelected = () => {
    if (
      this.state.applicationStatus === APPLICATIONSTATUSES.received ||
      this.state.applicationStatus === APPLICATIONSTATUSES.inReview ||
      this.state.applicationStatus === APPLICATIONSTATUSES.offeredPosition
    ) {
      return true;
    }
  };

  findCurrentStatus = () => {
    const currentStatus = this.state?.applicantStatusList?.find(
      (item) =>
        item.value === this.props?.applicants?.list?.data?.applicant_status,
    );
    this.setState({ applicantStatus: currentStatus?.value });
    return currentStatus?.label
      ? { label: currentStatus?.label, value: currentStatus?.value }
      : null;
  };

  findCurrentCrew() {
    if (this.findLabelsForCrewAndWhoSelected()) {
      return {
        label: this.props?.user?.profile?.data?.crew_name ?? '',
        value: this.props?.user?.profile?.data?.crew_identifier_id ?? '',
      };
    }

    return this.state?.applicant_details?.crew
      ? {
          label: this.state?.applicant_details?.crew?.resource_name ?? '',
          value: this.state?.applicant_details?.crew?.id ?? '',
        }
      : null;
  }

  findWhoSelected() {
    if (this.findLabelsForCrewAndWhoSelected()) {
      return {
        label: this.props?.user?.profile?.data?.full_name_last_first ?? '',
        value: this.props?.user?.profile?.data?.id ?? '',
      };
    }

    return this.state?.applicant_details?.performed_user
      ? {
          label: this.state?.applicant_details?.performed_user?.full_name || '',
          value: this.state?.applicant_details?.performed_user?.id || '',
        }
      : null;
  }

  componentWillReceiveProps(nextProps) {
    const applicants = nextProps.applicants.list;
    const user = nextProps;
    const { allAdmin } = nextProps.search;
    let user_list = [];
    const US_DATE_FORMAT =
      user?.user?.profile?.data?.date_formats?.US_DATE_FORMAT || 'MM/DD/YYYY';

    const { permission } = this.props;
    let permList = [];
    if (permission.permissions) {
      permList = permission.permissions.data;
    }
    const statuses = nextProps.listAll?.listAll?.ApplicantStatus?.filter(
      (item) => {
        // If the item is "Was Hired", check for the permission
        if (item.name === 'Was Hired') {
          return permList.includes('Finalize Hire');
        }
        // Allow all other statuses
        return true;
      },
    )?.map((item) => ({
      ...item,
      label: item.name,
    }));
    const applicantDetails = this.props?.applicants?.list?.data;
    const statusChangeDateAndTime = applicantDetails?.status_change_date;
    const interviewFormDate = applicantDetails?.interview_form_submission_date;
    this.setState({
      FULL_DATE_FORMAT:
        user?.user?.profile?.data?.date_formats?.FULL_DATE_FORMAT ?? 'MM/DD/YYYY',
    });

    this.setState({
      applicantStatusList: statuses,
      applicant_details: applicantDetails,
      rejectionReason: applicantDetails?.rejected_reason,
      date: moment(statusChangeDateAndTime).isValid()
        ? moment(statusChangeDateAndTime, this.state.FULL_DATE_FORMAT ?? 'MM/DD/YYYY')
        : moment(),
      time: moment(statusChangeDateAndTime).isValid()
        ? moment(statusChangeDateAndTime, this.state.FULL_DATE_FORMAT ?? 'MM/DD/YYYY')
        : moment(),
      whoRejected: applicantDetails?.performed_by,
      whoSelected: applicantDetails?.performed_by,
      hasInterviewForms: applicantDetails?.interview_form_count > 0,
      applicationStatus: this.props?.applicants?.list?.data?.applicant_status,
      interviewFormSubmissionDate: moment(interviewFormDate).isValid()
        ? moment(interviewFormDate).format(US_DATE_FORMAT)
        : '',
    });

    // Dispalys success alert message
    if (applicants) {
      if (applicants.success) {
        this.setState({
          hash: applicants.data.hash,
          email: applicants.data.email_address ?? '',
          applicant_list: applicants,
          notes: applicants.data.notes,
          application_history: applicants.data.application_history,
          admin_reason_for_leaving: applicants.data?.admin_reason_for_leaving,
        });
      } else {
        this.setState({
          alertPop: true,
          alertHead: 'Error',
          alertMsg: JSON.parse(JSON.stringify(applicants.message)),
          alertFunction: this.goBack,
        });
      }
    }
    if (allAdmin) {
      const userSearchList = allAdmin.data;
      if (userSearchList) {
        userSearchList.data.map((item, index) => {
          const name = item.first_name + ' ' + item.last_name;
          user_list.push(
            <li
              className='user_click'
              onClick={this.userClick.bind(this, name, item.email, item.hash)}
              key={index}
            >
              <span>{item.first_name + ' ' + item.last_name}</span>
              <img
                src={
                  item.profile_photo
                    ? config.apiUrl + '/' + item.profile_photo
                    : config.apiUrl + '/' + config.altImg
                }
                onError={this.onImageError.bind(this)}
                alt='profile_photo'
              />
            </li>,
          );
        });
        this.setState({ user_list });
      }
    }
    if (nextProps.enableStatusModal) {
      this.removeStatusOpenModal(
        applicants ? applicants.data.applicant_status : '',
      );
    }
  }

  statusOpenModal(hash, status, selectedApplicantNoInterviewForms) {
    this.setState({
      statusOpen: true,
      updateApplicantStatus: hash,
      currentStatusUpdate: status > -1 ? status : '',
      selectedApplicantNoInterviewForms,
    });
  }

  statusCloseModal() {
    this.setState({
      statusOpen: false,
      statusUpdating: false,
      selectedApplicantNoInterviewForms: false,
      forwardingNote: '',
    });
  }

  removeStatusOpenModal(status) {
    this.setState({ removeStatusOpen: true, currentStatusUpdate: status });
  }

  removeStatusCloseModal() {
    this.setState({ removeStatusOpen: false });
    this.props.setEnableStatusModal(false);
    this.setState({
      whoRejected: '',
      rejectionReason: '',
      whoSelected: '',
      crew: '',
    });
  }

  editApplicant(hash) {
    this.props.editApplicant(this.state.hash);
  }

  viewHistory() {
    this.props.viewHistory(this.state.hash);
  }

  closeAlert() {
    this.setState({
      alertPop: false,
    });
  }

  onImageError(e) {
    e.target.setAttribute('src', config.apiUrl + '/' + config.altImg);
  }

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  keyUpFn(e) {
    const textInput = document.getElementById('txtSearchUsersForForward');
    clearTimeout(this.state.timeout);
    this.state.timeout = setTimeout(
      function () {
        this.headerSearch(textInput.value);
      }.bind(this),
      1000,
    );
  }

  headerSearch(text) {
    let data = new FormData();
    data.append('keyword', text);

    if (text.length === 0) {
      this.setState({ hideSearch: 'hide' });
    } else if (text.length >= 1) {
      this.setState({ hideSearch: 'show', search_close: 'show' });
      this.props.dispatch(permissionActions.adminSearch(data));
    } else {
      this.setState({ formShow: 'show' });
    }
    this.props.dispatch(permissionActions.getPermission());
  }

  userClick(name, email, hash, event) {
    this.setState({ to: email, user_hash: hash });
    document.getElementById('txtSearchUsersForForward').value = name;
    this.setState({ hideSearch: 'hide' });
  }

  goBack() {
    window.location.href = '/applicants';
  }

  printManifest() {
    const hash = this.props.hash;
    const data = '?hash=' + hash + '';
    const requestOptions = {
      method: 'GET',
      headers: authHeader(),
    };

    fetch(config.apiUrl + '/api/printapplicant' + data, requestOptions)
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        redirectToPdfV2(data);
      });
  }

  sendMail() {
    const email = this.state.email || this.props.email || '';
    this.props.sendMail(email);
  }

  checkNull(value) {
    let flag = false;
    if (value === null) {
      flag = true;
    } else if (value === '') {
      flag = true;
    } else if (value === 'null') {
      flag = true;
    } else if (value === undefined) {
      flag = true;
    }
    return flag;
  }
  prevNext(hash) {
    this.props.dispatch(applicantsActions.viewDetails(hash));
  }

  updateApplicantStatus() {
    const {
      hash,
      applicantStatus,
      crew,
      rejectionReason,
      date,
      time,
      isConfirmUpdateModalOpen,
      hasInterviewForms,
    } = this.state;

    const isConfirmNeeded = [
      statusApplication.WAS_HIRED,
      statusApplication.NOT_SELECTED_ARCHIVE,
      statusApplication.DO_NOT_HIRE_ARCHIVE,
    ].includes(applicantStatus);

    if (
      [
        statusApplication.NOT_SELECTED_ARCHIVE,
        statusApplication.DO_NOT_HIRE_ARCHIVE,
      ].includes(applicantStatus) &&
      !rejectionReason?.length
    ) {
      return toast.error("The  notes on reason for rejection can't be empty.");
    }

    if (
      isConfirmNeeded &&
      this.props.applicants.list.data.applicant_status !== applicantStatus &&
      !isConfirmUpdateModalOpen
    ) {
      return this.setState({ isConfirmUpdateModalOpen: true });
    } else if (
      (applicantStatus === statusApplication.OFFERED_POSITION ||
        applicantStatus === statusApplication.WAS_HIRED) &&
      !hasInterviewForms
    ) {
      return toast.error(
        " The applicant hasn't filled out the interview form.",
      );
    }

    this.setState({ statusUpdating: true });

    let data = new FormData();
    data.append('hash', hash);
    data.append('action', applicantStatus);

    if (isConfirmNeeded) {
      if (applicantStatus === statusApplication.WAS_HIRED) {
        data.append(
          'crew_id',
          crew ? crew : this.props?.user?.profile?.data?.crew_identifier_id ?? '',
        );
      } else if (
        [
          statusApplication.DO_NOT_HIRE_ARCHIVE,
          statusApplication.NOT_SELECTED_ARCHIVE,
        ].includes(applicantStatus)
      ) {
        data.append('rejected_reason', rejectionReason);
      }
      data.append('performed_by', this.props?.user?.profile?.data?.id ?? '');
      data.append(
        'status_change_date',
        date && time
          ? `${moment(date).format('YYYY-MM-DD')} ${moment(time).format(
              'hh:mm:ss',
            )}`
          : null,
      );
    }

    this.props
      .dispatch(applicantsActions.removeApplicant(data))
      ?.then((res) => {
        if (res?.success) {
          this.goBack();
          this.removeStatusCloseModal();
          this.setState({
            isConfirmUpdateModalOpen: false,
            statusUpdating: false,
          });
          this.componentDidMount();
          this.setState({ statusUpdating: false });
        } else {
          handleErrorResponse(res);
          this.setState({ statusUpdating: false });
        }
      })
      ?.catch((err) => {
        throw err;
      });
  }

  forwardApplicant() {
    let data = new FormData();
    this.statusCloseModal();
    data.append('hash', this.state.hash);
    data.append('to', this.state.to || '');
    data.append('forward_note', this.state.forwardingNote);

    const self = this;
    fetch(config.apiUrl + '/api/forwardapplicant', {
      headers: authHeader(),
      method: 'POST',
      body: data,
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        if (data.success) {
          self.setState({
            alertPop: true,
            alertHead: 'Success',
            alertMsg: JSON.parse(JSON.stringify(data.message)),
            alertFunction: '',
            to: '',
            forwardingNote: '',
          });
        } else {
          self.setState({
            alertPop: true,
            alertHead: 'Error',
            alertMsg: JSON.parse(JSON.stringify(data.message)),
            alertFunction: '',
          });
        }
      });
  }

  onForwardingNote(e) {
    this.setState({ forwardingNote: e.target.value });
  }

  render() {
    const applicants = this.props.applicants.list;
    const status = applicants?.data?.status;

    let reference1 = [],
      reference2 = [],
      reference3 = [],
      applying_position = [],
      qualifications = [];

    let prevNext = [];

    if (applicants?.success) {
      if (this.props.applnType === '') {
        if (applicants?.data.previous !== null) {
          prevNext.push(
            <p
              key='prev'
              className='gotoPrev left'
              onClick={this.prevNext.bind(this, applicants.data.previous.hash)}
            >
              <span>Previous Applicant: </span>
              {applicants.data.previous.first_name +
                ' ' +
                applicants.data.previous.last_name}{' '}
            </p>,
          );
        }
        if (applicants?.data.next !== null) {
          prevNext.push(
            <p
              key='next'
              className='gotoNext right'
              onClick={this.prevNext.bind(this, applicants.data.next.hash)}
            >
              <span>Next Applicant: </span>
              {applicants.data.next.first_name +
                ' ' +
                applicants.data.next.last_name}{' '}
            </p>,
          );
        }
      }
    }

    const { permission } = this.props;
    let permList = [];
    if (permission.permissions) {
      permList = permission.permissions.data;
    }
    const loggedInUser = this.props?.user?.profile?.data || {};

    if (applicants?.success) {
      let reference1_start_date_Obj,
        reference1_end_date_Obj,
        reference2_start_date_Obj,
        reference2_end_date_Obj,
        reference3_start_date_Obj,
        reference3_end_date_Obj,
        reference1_date,
        reference2_date,
        reference3_date;

      if (applicants.data.reference1?.start_date !== '') {
        reference1_start_date_Obj = formatDate(
          applicants.data.reference1?.start_date,
        );
      } else {
        reference1_start_date_Obj = '';
      }

      if (applicants.data.reference1?.end_date !== '') {
        reference1_end_date_Obj = formatDate(
          applicants.data.reference1?.end_date,
        );
      } else {
        reference1_end_date_Obj = '';
      }

      if (applicants.data.reference2?.start_date !== '') {
        reference2_start_date_Obj = formatDate(
          applicants.data.reference2?.start_date,
        );
      } else {
        reference2_start_date_Obj = '';
      }

      if (applicants.data.reference2?.end_date !== '') {
        reference2_end_date_Obj = formatDate(
          applicants.data.reference2?.end_date,
        );
      } else {
        reference2_end_date_Obj = '';
      }

      if (applicants.data.reference3?.start_date !== '') {
        reference3_start_date_Obj = formatDate(
          applicants.data.reference3?.start_date,
        );
      } else {
        reference3_start_date_Obj = '';
      }

      if (applicants.data.reference3?.end_date !== '') {
        reference3_end_date_Obj = formatDate(
          applicants.data.reference3?.end_date,
        );
      } else {
        reference3_end_date_Obj = '';
      }

      if (reference3_start_date_Obj !== '' && reference3_end_date_Obj !== '') {
        reference3_date =
          reference3_start_date_Obj + ' - ' + reference3_end_date_Obj;
      } else {
        reference3_date = '';
      }
      if (reference2_start_date_Obj !== '' && reference2_end_date_Obj !== '') {
        reference2_date =
          reference2_start_date_Obj + ' - ' + reference2_end_date_Obj;
      } else {
        reference2_date = '';
      }
      if (reference1_start_date_Obj !== '' && reference1_end_date_Obj !== '') {
        reference1_date =
          reference1_start_date_Obj + ' - ' + reference1_end_date_Obj;
      } else {
        reference1_date = '';
      }

      if (
        applicants.data.reference1?.last_employee &&
        !this.checkNull(applicants.data.reference1.last_employee)
      ) {
        reference1.push(
          <div
            key='reference'
            id='avReference1'
            className='av-answer av-answer-clear'
          >
            <span>{applicants.data.reference1.last_employee}</span>
            {applicants.data.reference1.address &&
              applicants.data.reference1.address !== 'null' &&
              applicants.data.reference1.address !== null &&
              applicants.data.reference1.address !== '' && (
                <p className='view_inner_p'>
                  {applicants.data.reference1.address}
                  <br />
                </p>
              )}
            {applicants.data.reference1.city_id &&
              applicants.data.reference1.city_id !== 'null' &&
              applicants.data.reference1.city_id !== null &&
              applicants.data.reference1.city_id !== '' && (
                <p>{applicants.data.reference1.city_id}&nbsp;</p>
              )}
            {applicants.data.reference1.state_id &&
              applicants.data.reference1.state_id !== 'null' &&
              applicants.data.reference1.state_id !== null &&
              applicants.data.reference1.state_id !== '' && (
                <p className='view_inner_p'>
                  {applicants.data.reference1.state_id}
                </p>
              )}
            {applicants.data.reference1.position &&
              applicants.data.reference1.position !== 'null' &&
              applicants.data.reference1.position !== null &&
              applicants.data.reference1.position !== '' && (
                <p>{applicants.data.reference1.position}</p>
              )}
            {reference1_date && (
              <p className='view_inner_p'>{reference1_date}</p>
            )}
            {applicants.data.reference1.supervisor_name &&
              applicants.data.reference1.supervisor_name !== 'null' &&
              applicants.data.reference1.supervisor_name !== null &&
              applicants.data.reference1.supervisor_name !== '' && (
                <p>{applicants.data.reference1.supervisor_name}</p>
              )}
            {applicants.data.reference1.telephone &&
              applicants.data.reference1.telephone !== 'null' &&
              applicants.data.reference1.telephone !== null &&
              applicants.data.reference1.telephone !== '' && (
                <p>
                  (
                  <a
                    onClick={(event) => {
                      event.stopPropagation();
                    }}
                    className='phone_email_link'
                    href={`tel:${applicants.data.reference1.telephone}`}
                    target='_top'
                  >
                    {formatPhoneNumber(
                      applicants.data.reference1.telephone + ' (phone)',
                    )}
                  </a>
                  )
                </p>
              )}
            {applicants.data.reference1.fax &&
              applicants.data.reference1.fax !== 'null' &&
              applicants.data.reference1.fax !== null &&
              applicants.data.reference1.fax !== '' && (
                <p className='view_inner_p'>
                  {applicants.data.reference1.fax + ' (fax)'}
                </p>
              )}
            {applicants.data.reference1.responsibilities &&
              applicants.data.reference1.responsibilities !== 'null' &&
              applicants.data.reference1.responsibilities !== null &&
              applicants.data.reference1.responsibilities !== '' && (
                <p className='view_inner_p'>
                  <span>Responsabilities:</span>
                  <br />
                  <span>{applicants.data.reference1.responsibilities}</span>
                </p>
              )}
            {applicants.data.reference1.reason_for_leaving &&
              applicants.data.reference1.reason_for_leaving !== 'null' &&
              applicants.data.reference1.reason_for_leaving !== null &&
              applicants.data.reference1.reason_for_leaving !== '' && (
                <p className='view_inner_p'>
                  <span>Reason for Leaving:</span>
                  <br />
                  <span>{applicants.data.reference1.reason_for_leaving}</span>
                </p>
              )}
          </div>,
        );
      } else {
        reference1.push(
          <p
            key='reference'
            id='avReference1'
            className={`av-answer av-answer-clear`}
          >
            <span className={'av-empty disabled'}>
              Did not fill out
            </span>
          </p>,
        );
      }
      //
      if (
        applicants.data.reference2?.last_employee &&
        !this.checkNull(applicants.data.reference2.last_employee)
      ) {
        reference2.push(
          <div
            key='reference2'
            id='avReference2'
            className='av-answer av-answer-clear'
          >
            <p>{applicants.data.reference2.last_employee}</p>
            {applicants.data.reference2.address &&
              applicants.data.reference2.address !== 'null' &&
              applicants.data.reference2.address !== null &&
              applicants.data.reference2.address !== '' && (
                <p className='view_inner_p'>
                  {applicants.data.reference2.address}
                </p>
              )}
            {applicants.data.reference2.city_id &&
              applicants.data.reference2.city_id !== 'null' &&
              applicants.data.reference2.city_id !== null &&
              applicants.data.reference2.city_id !== '' && (
                <p>{applicants.data.reference2.city_id}&nbsp;</p>
              )}
            {applicants.data.reference2.state_id &&
              applicants.data.reference2.state_id !== 'null' &&
              applicants.data.reference2.state_id !== null &&
              applicants.data.reference2.state_id !== '' && (
                <p className='view_inner_p'>
                  {applicants.data.reference2.state_id}
                </p>
              )}
            {applicants.data.reference2.position &&
              applicants.data.reference2.position !== 'null' &&
              applicants.data.reference2.position !== null &&
              applicants.data.reference2.position !== '' && (
                <p>{applicants.data.reference2.position}</p>
              )}
            {reference2_date && (
              <p className='view_inner_p'>{reference2_date}</p>
            )}
            {applicants.data.reference2.supervisor_name &&
              applicants.data.reference2.supervisor_name !== 'null' &&
              applicants.data.reference2.supervisor_name !== null &&
              applicants.data.reference2.supervisor_name !== '' && (
                <p>{applicants.data.reference2.supervisor_name}</p>
              )}
            {applicants.data.reference2.telephone &&
              applicants.data.reference2.telephone !== 'null' &&
              applicants.data.reference2.telephone !== null &&
              applicants.data.reference2.telephone !== '' && (
                <p>
                  (
                  <a
                    onClick={(event) => {
                      event.stopPropagation();
                    }}
                    className='phone_email_link'
                    href={`tel:${applicants.data.reference2.telephone}`}
                    target='_top'
                  >
                    {formatPhoneNumber(
                      applicants.data.reference2.telephone + ' (phone)',
                    )}
                  </a>
                  )
                </p>
              )}
            {applicants.data.reference2.fax &&
              applicants.data.reference2.fax !== 'null' &&
              applicants.data.reference2.fax !== null &&
              applicants.data.reference2.fax !== '' && (
                <p className='view_inner_p'>
                  {applicants.data.reference2.fax + ' (fax)'}
                </p>
              )}
            {applicants.data.reference2.responsibilities &&
              applicants.data.reference2.responsibilities !== 'null' &&
              applicants.data.reference2.responsibilities !== null &&
              applicants.data.reference2.responsibilities !== '' && (
                <p className='view_inner_p'>
                  <span>Responsibilities:</span>
                  <br />
                  <span>{applicants.data.reference2.responsibilities}</span>
                </p>
              )}
            {applicants.data.reference2.reason_for_leaving &&
              applicants.data.reference2.reason_for_leaving !== 'null' &&
              applicants.data.reference2.reason_for_leaving !== null &&
              applicants.data.reference2.reason_for_leaving !== '' && (
                <p className='view_inner_p'>
                  <span>Reason for Leaving:</span>
                  <br />
                  <span>{applicants.data.reference2.reason_for_leaving}</span>
                </p>
              )}
          </div>,
        );
      } else {
        reference2.push(
          <p
            key='reference2'
            id='avReference2'
            className='av-answer av-answer-clear'
          >
            <span className={'av-empty disabled'}>
              Did not fill out
            </span>
          </p>,
        );
      }
      //

      if (
        applicants.data.reference3?.last_employee &&
        !this.checkNull(applicants.data.reference3.last_employee)
      ) {
        reference3.push(
          <div
            key='reference3'
            id='avReference3'
            className='av-answer av-answer-clear'
          >
            <p>{applicants.data.reference3.last_employee}</p>
            {applicants.data.reference3.address &&
              applicants.data.reference3.address !== 'null' &&
              applicants.data.reference3.address !== null &&
              applicants.data.reference3.address !== '' && (
                <p className='view_inner_p'>
                  {applicants.data.reference3.address}
                </p>
              )}
            {applicants.data.reference3.city_id &&
              applicants.data.reference3.city_id !== 'null' &&
              applicants.data.reference3.city_id !== null &&
              applicants.data.reference3.city_id !== '' && (
                <p>{applicants.data.reference3.city_id}&nbsp;</p>
              )}
            {applicants.data.reference3.state_id &&
              applicants.data.reference3.state_id !== 'null' &&
              applicants.data.reference3.state_id !== null &&
              applicants.data.reference3.state_id !== '' && (
                <p className='view_inner_p'>
                  {applicants.data.reference3.state_id}
                </p>
              )}
            {applicants.data.reference3.position &&
              applicants.data.reference3.position !== 'null' &&
              applicants.data.reference3.position !== null &&
              applicants.data.reference3.position !== '' && (
                <span>{applicants.data.reference3.position}</span>
              )}
            {reference3_date && (
              <p className='view_inner_p'>{reference3_date}</p>
            )}
            {applicants.data.reference3.supervisor_name &&
              applicants.data.reference3.supervisor_name !== 'null' &&
              applicants.data.reference3.supervisor_name !== null &&
              applicants.data.reference3.supervisor_name !== '' && (
                <p>{applicants.data.reference3.supervisor_name}</p>
              )}
            {applicants.data.reference3.telephone &&
              applicants.data.reference3.telephone !== 'null' &&
              applicants.data.reference3.telephone !== null &&
              applicants.data.reference3.telephone !== '' && (
                <p>
                  (
                  <a
                    onClick={(event) => {
                      event.stopPropagation();
                    }}
                    className='phone_email_link'
                    href={`tel:${applicants.data.reference3.telephone}`}
                    target='_top'
                  >
                    {formatPhoneNumber(
                      applicants.data.reference3.telephone + ' (phone)',
                    )}
                  </a>
                  )
                </p>
              )}
            {applicants.data.reference3.fax &&
              applicants.data.reference3.fax !== 'null' &&
              applicants.data.reference3.fax !== null &&
              applicants.data.reference3.fax !== '' && (
                <p className='view_inner_p'>
                  {applicants.data.reference3.fax + ' (fax)'}
                </p>
              )}
            {applicants.data.reference3.responsibilities &&
              applicants.data.reference3.responsibilities !== 'null' &&
              applicants.data.reference3.responsibilities !== null &&
              applicants.data.reference3.responsibilities !== '' && (
                <p className='view_inner_p'>
                  <span>Responsabilities:</span>
                  <br />
                  <span>{applicants.data.reference3.responsibilities}</span>
                </p>
              )}
            {applicants.data.reference3.reason_for_leaving &&
              applicants.data.reference3.reason_for_leaving !== 'null' &&
              applicants.data.reference3.reason_for_leaving !== null &&
              applicants.data.reference3.reason_for_leaving !== '' && (
                <p className='view_inner_p'>
                  <span>Reason for Leaving:</span>
                  <br />
                  <span>{applicants.data.reference3.reason_for_leaving}</span>
                </p>
              )}
          </div>,
        );
      } else {
        reference3.push(
          <p
            key='reference3'
            id='avReference3'
            className='av-answer av-answer-clear'
          >
            <span className={'av-empty disabled'}>
              Did not fill out
            </span>
          </p>,
        );
      }

      if (
        applicants.data.applying_position_id !== null &&
        applicants.data.applying_position_id !== 'null' &&
        applicants.data.applying_position_id !== ''
      ) {
        applicants.data.applying_position.map((item, index) => {
          applying_position.push(<p key={index}>{item}</p>);
        });
      } else {
        applying_position.push(
          <span key='empty' className='av-empty'>
            Did not fill out
          </span>,
        );
      }

      if (
        applicants.data.qualification_id !== null &&
        applicants.data.qualification_id !== 'null' &&
        applicants.data.qualification_id !== ''
      ) {
        applicants.data.qualification.map((item, index) => {
          qualifications.push(<p key={index}>{item}</p>);
        });
      } else {
        qualifications.push(
          <span key='empty' className='av-empty'>
            Did not fill out
          </span>,
        );
      }
    }
    //

    return (
      <div className='applicants_container application_details'>
        <div className='applicant_hdr_btn_grp'>
          <h3 className='left'>Job Application</h3>
          {applicants?.data?.former_employee_approval ? (
            <h4 style={{ color: 'red' }}>FORMER EMPLOYEE</h4>
          ) : (
            <></>
          )}
        </div>
        <div className='top_btn_group new_btn_grp flex-group'>
          {[
            contactEmailConstants.HR,
            contactEmailConstants.TEST_ADMIN,
            contactEmailConstants.JIMMY_DO,
          ].includes(loggedInUser?.email) &&
          applicants?.data?.former_employee_approval == 1 ? (
            <button
              className='button'
              onClick={this.formerEmpOpenModal.bind(this)}
            >
              Approve/Reject
            </button>
          ) : (
            <></>
          )}
          {permList.includes('Manage Applicants') &&
            this.props.isApplicationEditable && (
              <button
                className='button'
                onClick={this.editApplicant.bind(this, this.props.hash)}
              >
                Edit
              </button>
            )}

          {permList.includes('Manage Applicants') && (
            <>
              {status === statusApplication.WAS_HIRED &&
                applicants?.data?.registration_status == 0 && (
                  <button
                    className='button'
                    onClick={this.onboardingEmailStatusOpenModal.bind(this)}
                  >
                    Resend Onboarding Email
                  </button>
                )}

              <button
                className='button'
                onClick={this.printManifest.bind(this)}
              >
                Print
              </button>
              <button
                className='button'
                onClick={this.statusOpenModal.bind(this)}
              >
                Forward
              </button>
            </>
          )}

          {permList.includes('Modify SMS Notification Preference') &&
          applicants ? (
            <SmsNotification
              initialStatus={applicants.data.sms_notify}
              providerOptedOutStatus={applicants.data.sms_provider_opt_out}
              type={profileType.APPLICATION}
              id={applicants.data.id}
              customClass={'edit_profile xl-font'}
            />
          ) : (
            <></>
          )}
        </div>
        {this.state.application_history.length > 1 && (
          <div className='applicants_inner_head inner_head'>
            <div
              className='previous_history'
              onClick={this.viewHistory.bind(this)}
            >
              <img
                src={
                  require('../assets/images/history-clock-button.svg').default
                }
                alt=''
              />
              <span>View Previous History</span>
            </div>
          </div>
        )}
        <div
          className='inner_container tab_inner_container col-lg-12'
          id='applicants_inner'
        >
          <div className='clearfix' />

          {applicants?.data && (
            <ApplicantDetailsSection applicants={applicants} />
          )}

          <div className='clearfix' />
        </div>

        <ReactModal
          isOpen={this.state.statusOpen}
          onClose={this.statusCloseModal.bind(this)}
          contentLabel='Minimal Modal Example'
          overlayClassName='ForwardPopup'
        >
          <div className='modal-head'>
            <h4 className='modal-title'>Forward Application</h4>
            <img
              className='closeModal'
              onClick={this.statusCloseModal.bind(this)}
              src={require('../assets/images/close_green.png').default}
              alt=''
            />
          </div>
          <div className='modal-body' id='allAdminPopup'>
            <div className='status_step step1'>
              <div className='employee-list-input'>
                <label>Search User:</label>
                <br />
                <input
                  name='to'
                  className='txtSearchUsersForForward'
                  id='txtSearchUsersForForward'
                  onKeyUp={this.keyUpFn}
                  autoComplete='off'
                />

                <ul
                  id='searchResultTop'
                  className={`${this.state.hideSearch} employee-list`}
                >
                  {this.state.user_list}
                </ul>
              </div>
              <label>Note:</label>
              <br />
              <textarea
                name='to'
                className='forward-applicant-note'
                id='forward-applicant-note'
                onChange={this.onForwardingNote}
                autoComplete='off'
              />
              <div className='btn_list'>
                <button
                  className='button grey'
                  onClick={this.statusCloseModal.bind(this)}
                >
                  Cancel
                </button>
                <button
                  className='button'
                  onClick={this.forwardApplicant.bind(this)}
                  disabled={!this.state.to}
                >
                  Email
                </button>
              </div>
            </div>
          </div>
        </ReactModal>

        <Modal
          isOpen={this.state.onboardingEmailStatusOpen}
          className='update-applicant-status-modal'
        >
          <div className='modal-head'>
            <h4>Resend Onboarding Email</h4>
          </div>

          <div className='modal-body applicant-status-modal-body'>
            <p>
              Are you sure you want to resend the onboarding email to{' '}
              {applicants?.data.email_address}?
            </p>
            <div className='button-holder button-holder--right'>
              <button
                disabled={false}
                className='button grey'
                onClick={this.onboardingEmailStatusCloseModal.bind(this)}
              >
                Cancel
              </button>
              <button
                disabled={this.state.sendingOnboardingEmail}
                className='button'
                onClick={this.sendOnboardingEmail.bind(this)}
              >
                Send
              </button>
            </div>
          </div>
        </Modal>

        <Modal
          isOpen={this.state.formerEmpModal}
          className='update-applicant-status-modal'
        >
          <div className='modal-head'>
            <h4>Approve / Reject Application</h4>
          </div>

          <div className='modal-body applicant-status-modal-body'>
            <p>
              Note: Approving the application will move this application to
              Applicants List and rejecting will move this to Archived
              Applicants List.
            </p>
            <div className='status-select input-holder 1'>
              <span>Status</span>
              <select
                value={this.state.formerEmpApproval}
                onChange={this.handleSelect.bind(this)}
              >
                <option value=''>--</option>
                <option value='2'>Approve</option>
                <option value='3'>Reject</option>
              </select>
            </div>

            <>
              <div className='button-holder button-holder--right'>
                <button
                  disabled={false}
                  className='button grey'
                  onClick={this.formerEmpCloseModal.bind(this)}
                >
                  Cancel
                </button>
                <button
                  disabled={
                    !this.state.formerEmpApproval || this.state.statusUpdating
                  }
                  className='button'
                  onClick={this.changeFormerEmpApprovalStatus.bind(this)}
                >
                  Update
                </button>
              </div>
            </>
          </div>
        </Modal>

        <Modal
          isOpen={this.state.removeStatusOpen}
          className='update-applicant-status-modal'
        >
          <div className='modal-head'>
            <h4>UPDATE APPLICANT STATUS</h4>
          </div>

          <div className='modal-body applicant-status-modal-body'>
            {this?.state?.applicant_list?.data?.interview_form_count === 0 && (
              <NoInterviewFormAlert />
            )}

            {this.state?.applicantStatusList && (
              <div className='status-select input-holder 1'>
                <span>Status</span>
                <Select
                  options={this.state.applicantStatusList}
                  defaultValue={this.findCurrentStatus}
                  onChange={(selection) =>
                    this.onChangeSelect(selection, 'applicantStatus')
                  }
                  classNamePrefix='select'
                />
              </div>
            )}

            {this.state.applicantStatus === statusApplication.WAS_HIRED && (
              <>
                <div className='crew-select input-holder'>
                  <span>Crew</span>
                  <AsyncSelect
                    loadOptions={(value, callback) =>
                      this.loadOptions(value, callback, 'crew')
                    }
                    onChange={(selection) =>
                      this.onChangeSelect(selection, 'crew')
                    }
                    defaultValue={this.findCurrentCrew}
                    placeholder='Search'
                    classNamePrefix='select'
                    isDisabled={true}
                    components={{
                      DropdownIndicator: () => null,
                      IndicatorSeparator: () => null,
                    }}
                  />
                </div>
                <div className='who-select input-holder'>
                  <span>Who selected them?</span>
                  <AsyncSelect
                    loadOptions={(value, callback) =>
                      this.loadOptions(value, callback, 'who selected')
                    }
                    onChange={(selection) =>
                      this.onChangeSelect(selection, 'whoSelected')
                    }
                    defaultValue={this.findWhoSelected}
                    placeholder='Search'
                    classNamePrefix='select'
                    isDisabled={true}
                    components={{
                      DropdownIndicator: () => null,
                      IndicatorSeparator: () => null,
                    }}
                  />
                </div>
              </>
            )}

            {[
              statusApplication.DO_NOT_HIRE_ARCHIVE,
              statusApplication.NOT_SELECTED_ARCHIVE,
            ].includes(this.state.applicantStatus) && (
              <>
                <div className='who-select input-holder'>
                  <span>Who rejected them?</span>
                  <AsyncSelect
                    loadOptions={(value, callback) =>
                      this.loadOptions(value, callback, 'who rejected')
                    }
                    onChange={(selection) =>
                      this.onChangeSelect(selection, 'whoRejected')
                    }
                    defaultValue={this.findWhoSelected}
                    placeholder='Search'
                    classNamePrefix='select'
                    isDisabled={true}
                    components={{
                      DropdownIndicator: () => null,
                      IndicatorSeparator: () => null,
                    }}
                  />
                </div>
                <div className='rejection-notes'>
                  <span>Notes on why the application was rejected</span>
                  <textarea
                    rows='5'
                    value={this.state.rejectionReason}
                    onChange={(e) =>
                      this.setState({ rejectionReason: e.target.value })
                    }
                  />
                </div>
              </>
            )}

            {[
              statusApplication.WAS_HIRED,
              statusApplication.NOT_SELECTED_ARCHIVE,
              statusApplication.DO_NOT_HIRE_ARCHIVE,
            ].includes(this.state.applicantStatus) && (
              <div className='date-time input-holder'>
                <span>Date and time</span>
                <DateAndTimePicker
                  date={this.state.date}
                  onChangeDate={this.onChangeUpdateApplicantDate}
                  time={this.state.time}
                  onChangeTime={this.onChangeUpdateApplicantTime}
                  disabled={true}
                />
              </div>
            )}

            <div className='button-holder button-holder--right'>
              <button
                disabled={false}
                className='button grey'
                onClick={this.removeStatusCloseModal.bind(this)}
              >
                Cancel
              </button>
              <button
                disabled={
                  this?.state?.statusUpdating ||
                  this.props?.applicants?.list?.data?.applicant_status ===
                    this?.state?.applicantStatus
                }
                className='button'
                onClick={this.updateApplicantStatus.bind(this)}
              >
                Update
              </button>
            </div>
          </div>
        </Modal>

        <Modal
          isOpen={this.state.isConfirmUpdateModalOpen}
          className='update-applicant-status-modal update-applicant-status-modal--sec'
        >
          <div className='modal-head'>
            <h4 className='text-left'>Confirm Status Update</h4>
          </div>
          <div className='modal-body applicant-status-modal-body'>
            <p>
              An email notification will be sent to both the applicant and the
              respective authority.
            </p>
            <>
              <div className='button-holder button-holder--right'>
                <button
                  disabled={false}
                  className='button grey'
                  onClick={() =>
                    this.setState({ isConfirmUpdateModalOpen: false })
                  }
                >
                  Cancel
                </button>
                <button
                  disabled={this?.state?.statusUpdating}
                  className='button'
                  onClick={this.updateApplicantStatus.bind(this)}
                >
                  Confirm
                </button>
              </div>
            </>
          </div>
        </Modal>

        {this.state.alertPop && (
          <AlertPopup
            head={this.state.alertHead}
            message={this.state.alertMsg}
            viewOpen='true'
            alertFunction={this.state.alertFunction}
            close={this.closeAlert.bind(this)}
          />
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  const {
    applicants,
    permission,
    search,
    user,
    createProfile: listAll,
  } = state;

  return {
    applicants,
    permission,
    search,
    listAll,
    user,
  };
}

const connectedHomePage = connect(mapStateToProps)(ViewApplicant);
export { connectedHomePage as ViewApplicant };

ViewApplicant.propTypes = {
  hash: PropTypes.string,
  email: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  dispatch: PropTypes.func.isRequired,
  applicants: PropTypes.object,
  permission: PropTypes.object,
  user: PropTypes.object,
  search: PropTypes.object,
  listAll: PropTypes.object,
  enableStatusModal: PropTypes.bool,
  setEnableStatusModal: PropTypes.func,
  editApplicant: PropTypes.func,
  viewHistory: PropTypes.func,
  sendMail: PropTypes.func,
  applnType: PropTypes.string,
  isApplicationEditable: PropTypes.bool,
};
